export default {"src":"/_next/static/media/visual-query.2b063819.svg","height":175,"width":430,"blurWidth":0,"blurHeight":0};